import { createMemoStyles } from '@wds/styles';
import { PricingAppTheme } from '~app/styles/pricing/types';
import { MD_MEDIA_QUERY } from '~shared/media-query';

export default createMemoStyles(({ spacing, type }: PricingAppTheme) => ({
  Header: {
    paddingBottom: spacing[8],
  },
  IPPMPackages: {
    padding: [0, spacing[3], spacing[4]],

    '& [class^="PackagesContainer-"]': {
      padding: 0,
    },

    '& [class^="PricingPackage-"]': {
      marginBottom: 0,
    },
  },
  MainHeadingStyle: {
    '& h1': {
      margin: [spacing[5], spacing[3], spacing[2]],
      [MD_MEDIA_QUERY]: {
        margin: [spacing[6], 'auto', spacing[2]],
      },
    },
  },
}));
